import { useRouter } from 'next/router'
import WebviewContainer from '../../../../../../components/webview/WebviewContainer'
import { n_caf } from '../../../../../../modules/i18n/strings/auto/wording_webview'
import useTranslation from '../../../../../../modules/i18n/useTranslation'
import {
  IC_CAF_ACCURACY_LEVEL,
  IC_CAF_COMPLEXITY_LEVEL,
  IC_CAF_FLUENCY_LEVEL,
  IC_CAF_MY_LEVEL,
  IC_CAF_OVERVIEW_LEVEL,
  IC_CAF_PRONUNCIATION_LEVEL,
} from '../../../../../../modules/images'

export const CAF_LEVEL_IMAGE = {
  Complexity: IC_CAF_COMPLEXITY_LEVEL,
  Accuracy: IC_CAF_ACCURACY_LEVEL,
  Fluency: IC_CAF_FLUENCY_LEVEL,
  Pronunciation: IC_CAF_PRONUNCIATION_LEVEL,
  Overview: IC_CAF_OVERVIEW_LEVEL,
}

export const CAF_LEVEL_TAG = {
  Complexity: {
    title: n_caf.level_detail.c.title,
    tag: 'c',
    per: ['0.6', '4.2', '14.9', '34.4', '31.8', '12.6', '1.5', '0', '0'],
  },
  Accuracy: {
    title: n_caf.level_detail.c.title,
    tag: 'a',
    per: ['0.6', '5.3', '19.8', '43.9', '22.5', '6.8', '1.0', '0', '0'],
  },
  Fluency: {
    title: n_caf.level_detail.c.title,
    tag: 'f',
    per: ['0.3', '2.5', '18.2', '50.1', '22.2', '5.6', '1.1', '0', '0'],
  },
  Pronunciation: {
    title: n_caf.level_detail.p.title,
    tag: 'p',
    per: ['0.2', '0.8', '3.0', '16.7', '31.3', '45.6', '2.3', '0', '0'],
  },
  // CAF Level은 3차 베타에서 삭제, 추후 다시 도입될 예정
  Overview: {
    per: ['1.1', '3.6', '10.8', '33.2', '42.0', '8.9', '0.3', '0', '0'],
  },
}

export const NUMS = [9, 8, 7, 6, 5, 4, 3, 2, 1]

export type TAG = {
  status: string
  level: number
  [key: string]: any
}

const CAFLevel = () => {
  const router = useRouter()
  const { t } = useTranslation()

  const { status, level } = router.query as TAG

  if (!status) return null
  return (
    <WebviewContainer title={status === 'Overview' ? 'CAF Level' : status + ' Level'}>
      <div className="p-20">
        <div className="relative">
          <img
            src={IC_CAF_MY_LEVEL}
            width={60}
            height={147}
            alt="score"
            className="absolute"
            style={{
              left: level >= 9 ? '85%' : `${(100 / 7) * (level - 3)}%`,
              top: '16%',
            }}
          />
          <img src={CAF_LEVEL_IMAGE[status]} className="w-full" alt="level" />
        </div>
        <div className="text-14 mt-12 text-gray-700">{t(n_caf.level_detail.stat_info)}</div>
        <div className="h-32" />
        {status !== 'Overview' ? (
          <>
            {NUMS.map((item, idx) => (
              <div className="border-b-1 flex justify-between gap-[21px] border-gray-200 py-[12px]" key={item}>
                <div className="shrink-0">
                  <span className="text-16 font-bold">
                    {t(n_caf.complexity.level_score)} {item}
                  </span>
                  <div className="text-12 mt-4 font-medium text-gray-700">{CAF_LEVEL_TAG[status]['per'][idx]}%</div>
                </div>
                <span className="text-14 flex-grow text-left text-gray-700">
                  {t(n_caf.level_detail[CAF_LEVEL_TAG[status]['tag']][`level${item}`])}
                </span>
              </div>
            ))}
          </>
        ) : (
          <>
            {NUMS.map((item, idx) => (
              <div className="border-b-1 flex justify-center border-gray-200 py-12" key={item}>
                <span className="text-16 w-[70px] font-bold">
                  {t(n_caf.complexity.level_score)} {item}
                </span>
                <div className="text-12 mt-3 w-[35px] font-medium text-gray-700">
                  {CAF_LEVEL_TAG[status]['per'][idx]}%
                </div>
              </div>
            ))}
          </>
        )}
      </div>
    </WebviewContainer>
  )
}
interface ContentProps {
  level: number
}
export const CAFLevelContent = ({ level }: ContentProps) => {
  const { t } = useTranslation()
  return (
    <div className="p-20">
      <div className="relative">
        <img
          src={IC_CAF_MY_LEVEL}
          width={60}
          height={147}
          alt="score"
          className="absolute"
          style={{
            left: level >= 9 ? '85%' : `${(100 / 7) * (level - 3)}%`,
            top: '16%',
          }}
        />
        <img src={CAF_LEVEL_IMAGE[status]} className="w-full" alt="level" />
      </div>
      <div className="text-14 mt-12 text-gray-700">{t(n_caf.level_detail.stat_info)}</div>
      <div className="h-32" />
      {status !== 'Overview' ? (
        <>
          {NUMS.map((item, idx) => (
            <div className="border-b-1 flex justify-between gap-[21px] border-gray-200 py-[12px]" key={item}>
              <div className="shrink-0">
                <span className="text-16 font-bold">
                  {t(n_caf.complexity.level_score)} {item}
                </span>
                <div className="text-12 mt-4 font-medium text-gray-700">{CAF_LEVEL_TAG[status]['per'][idx]}%</div>
              </div>
              <span className="text-14 flex-grow text-left text-gray-700">
                {t(n_caf.level_detail[CAF_LEVEL_TAG[status]['tag']][`level${item}`])}
              </span>
            </div>
          ))}
        </>
      ) : (
        <>
          {NUMS.map((item, idx) => (
            <div className="border-b-1 flex justify-center border-gray-200 py-12" key={item}>
              <span className="text-16 w-[70px] font-bold">
                {t(n_caf.complexity.level_score)} {item}
              </span>
              <div className="text-12 mt-3 w-[35px] font-medium text-gray-700">
                {CAF_LEVEL_TAG[status]['per'][idx]}%
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  )
}

export default CAFLevel
